'use client'
import Image1 from '@/assets/images/ServiceDocuments/1.png'
import Image2 from '@/assets/images/ServiceDocuments/2.png'
import Image3 from '@/assets/images/ServiceDocuments/3.png'
import Image4 from '@/assets/images/ServiceDocuments/4.png'
import Image5 from '@/assets/images/ServiceDocuments/5.png'
import Image6 from '@/assets/images/ServiceDocuments/6.png'
import Image7 from '@/assets/images/ServiceDocuments/7.png'
import { Breadcrumbs } from '@/components/Breadcrumbs'
import { Button } from '@/components/Button'
import { ButtonLink } from '@/components/ButtonLink'
import { PageTitle } from '@/components/PageTitle'
import { WITH_REVIEW_WIDGET } from '@/config'
import { IconName } from '@/icons'
import { Content } from '@/modules/ArticlePage/components/Content'
import { Subscription } from '@/modules/Subscription'
import { Article, Member, RecommendedService } from '@/services/Api/generated'
import { ContentItem } from '@/utils/editor'
import cn from 'classnames'
import Script from 'next/script'
import { FunctionComponent, useCallback, useMemo, useRef } from 'react'
import { SliderDocuments } from '../../components/SliderDocuments'
import { Advantages } from '../AboutPage/components/Advantages'
import { CompanyValues } from '../AboutPage/components/CompanyValues'
import { Team } from '../AboutPage/components/Teams'
import { HelpForm } from '../HelpForm'
import styles from './ServicePage.module.scss'
import { Articles } from './components/Articles'
import { Services } from './components/Services'

const DOCUMENTS_IMAGES = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
]

const advantages: { title: string; description: string; icon: IconName }[] = [
  {
    title: 'Свой штат экспертов',
    description: 'патентные поверенные, юристы',
    icon: 'expert',
  },
  {
    title: '10 лет опыта',
    description: 'средний стаж сотрудников компании',
    icon: 'union',
  },
  {
    title: '97% наших заявок',
    description: 'успешно зарегистрированы Роспатентом',
    icon: 'fileCheck',
  },
]

type ServicePageProps = {
  title: string
  content: ContentItem[]
  recommendedServices: RecommendedService[]
  recommendedBlog?: Article[]
  companyMembers: Member[]
  breadcrumbs?: { slug: string; title: string }[]
}
export const ServicePage: FunctionComponent<ServicePageProps> = ({
  title,
  content,
  recommendedServices,
  recommendedBlog = [],
  companyMembers,
  breadcrumbs = [],
}) => {
  const helpFormRef = useRef<HTMLFormElement>(null)

  const breadcrumbsLinks = useMemo(
    () => [
      { url: '/', name: 'Главная' },
      ...breadcrumbs.map((breadcrumb) => ({
        url: `/uslugi/${breadcrumb.slug}`,
        name: breadcrumb.title,
      })),
    ],
    [breadcrumbs]
  )

  const scrollToHelpForm = useCallback(() => {
    const el = helpFormRef.current
    if (el != null) {
      const rect = el.getBoundingClientRect()
      const target = window.pageYOffset + rect.top - 100
      window.scrollTo({ top: target, behavior: 'smooth' })
    }
  }, [])

  return (
    <>
      <Breadcrumbs items={breadcrumbsLinks} />
      <div className={cn(styles.container, styles.header)}>
        <PageTitle className={styles.pageTitle} title={title} />
      </div>
      <div className={styles.headerButtons}>
        <ButtonLink href="/prices" className={styles.headerButton}>
          Цены
        </ButtonLink>
        <Button className={styles.headerButton} onClick={scrollToHelpForm}>
          Записаться
        </Button>
      </div>

      {/* CONTENT */}
      <Content content={content} className={styles.content} />

      {companyMembers.length !== 0 ? (
        <Team
          className={styles.team}
          members={companyMembers}
          withoutHeaderTag
        />
      ) : null}

      <CompanyValues className={styles.companyValues} withoutImage />

      {WITH_REVIEW_WIDGET ? (
        <div className={styles.reviewWidget}>
          <Script src="https://app.reviewlab.ru/widget/index-es2015.js" defer />
        </div>
      ) : null}

      <Advantages className={styles.advantages} list={advantages} />

      <div className={cn(styles.documents)}>
        <SliderDocuments
          images={DOCUMENTS_IMAGES}
          title="Документы и лицензии"
        />
      </div>

      <div className={styles.services}>
        <Services services={recommendedServices} />
      </div>

      {recommendedBlog != null && recommendedBlog.length !== 0 ? (
        <div className={styles.recomendedSliderWrapper}>
          <div className={styles.title}>Полезные материалы</div>
          <Articles
            articles={recommendedBlog}
            className={styles.recomendedSlider}
          />
        </div>
      ) : null}

      <HelpForm ref={helpFormRef} className={styles.helpForm} />

      <Subscription className={styles.subscription} />
    </>
  )
}
